





import { mapState } from 'vuex'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  computed: {
    ...mapState({
      categoriesIds: state => state.classifieds.form.categoriesIds,
      title: state => state.page.title
    })
  }
})
